import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@bt/shared';
import {NgSelectizeModule} from 'ng-selectize';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TransactionsComponent } from './transactions.component';

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      SharedModule,
      NgSelectizeModule,
      FontAwesomeModule
    ],
    declarations: [
        TransactionsComponent,
    ],
  })
  export class TransactionsModule { }


// WEBPACK FOOTER //
// ./src/app/transactions/transactions.module.ts